import { BaseWebComponentElement } from '../../../../../../../../framework/BaseWebComponentElement';
import { PatchesGridController } from '../controller/PatchesGridController';
import { TaskTarget } from '../../../../../../types';

export class PatchesGridWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PatchesGridController,
    });
  }

  set targets(value: Array<TaskTarget>) {
    this.setAttribute('data-targets', JSON.stringify(value));
  }

  get targets(): Array<TaskTarget> {
    const value = this.getAttribute('data-targets');
    return value ? JSON.parse(value) : [];
  }
}
